import { useNavigate, useParams } from "react-router";
import { useSamplesDustDensityBaseDataShowQuery } from "@/services/backend/samples/api/dust-density-base-data-api";
import { DustDensityBaseDataFields } from "@/services/backend/samples/components/dust-density-base-data-fields";
import { DeleteDustDensityBaseDataDialog } from "@/services/backend/samples/components/delete-dust-density-base-data-dialog";
import { SampleBaseDataDetailCard } from "@/routes/base-data/samples/_components/sample-base-data-detail-card";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";

export function DustDensityBaseDataRoute() {
  const { baseDataId } = useParams();
  const navigate = useNavigate();

  const {
    data: baseData,
    isLoading,
    error,
  } = useSamplesDustDensityBaseDataShowQuery({ id: baseDataId! });

  return (
    <PersistenceContextProvider>
      <SampleBaseDataDetailCard
        baseData={baseData}
        isLoading={isLoading}
        error={error}
        actions={
          baseData && (
            <DeleteDustDensityBaseDataDialog
              baseData={baseData}
              onDeleted={() => navigate("..")}
            />
          )
        }
      >
        {baseData && <DustDensityBaseDataFields id={baseData.id} />}
      </SampleBaseDataDetailCard>
    </PersistenceContextProvider>
  );
}
